import BiBaseDataItem from '../common/bi-base-item';
import { createController } from './platform-actions';

/**
 * Represents the "load started" bi event:
 * It should be used to monitor the initial application load.
 */
export default class BiPlatformLoadStartDataItem extends BiBaseDataItem {
  constructor(sessionId, appId, widgetId, isServerSide, metasiteId) {
    super(300, sessionId);

    this.data.actionName = createController;
    this.data.appId = appId;
    this.data.widgetId = widgetId;
    this.data.isServerSide = isServerSide;
    this.data.msid = metasiteId;

    /*
    actionDurationMs
    actionName
    appId
    isServerSide
    msid
    pageId
    pageUrl
    pn
    postSSR
    requestId
    ts
    tsn
    widgetArray
    widgetId
    */
  }
}
